import React, { useState } from 'react';
import gradientLargerCard from '../assets/images/gradient-larger-card-mobile.svg';
import gradientDesignCard from '../assets/images/gradient-design-card.svg';
import gradientDevelopmentCard from '../assets/images/gradient-development-card.svg';
import gradientMarketingCard from '../assets/images/gradient-marketing-card.svg';
import iconDesign from '../assets/images/icon-design.svg';
import iconDevelopment from '../assets/images/icon-development.svg';
import iconMarketing from '../assets/images/icon-marketing.svg';
import useSolutionsLogic from '../hooks/useSolutionsLogic';
import styles from '../styles/stylesSolutionsMobile';
import '../styles/stylesSolutionsGlobal';

function SolutionsMobile() {
  const [isHoveredLarge, setIsHoveredLarge] = useState(false);
  const [isHoveredDesign, setIsHoveredDesign] = useState(false);
  const [isHoveredDev, setIsHoveredDev] = useState(false);
  const [isHoveredMarketing, setIsHoveredMarketing] = useState(false);

  const cards = [
    {
      isHovered: isHoveredDesign,
      setHover: setIsHoveredDesign,
      gradient: gradientDesignCard,
      icon: iconDesign,
      title: "Design",
      text: "Interfaces e experiências visuais que encantam, priorizando usabilidade, estética e alinhamento com a identidade da sua marca."
    },
    {
      isHovered: isHoveredDev,
      setHover: setIsHoveredDev,
      gradient: gradientDevelopmentCard,
      icon: iconDevelopment,
      title: "Desenvolvimento",
      text: "Plataformas web e aplicativos nativos robustos, focados em alta performance, escalabilidade e soluções personalizadas."
    },
    {
      isHovered: isHoveredMarketing,
      setHover: setIsHoveredMarketing,
      gradient: gradientMarketingCard,
      icon: iconMarketing,
      title: "Marketing",
      text: "Campanhas digitais orientadas, combinando branding, criatividade e resultados para ampliar sua presença no mercado."
    }
  ];

  return (
    <section id="solutions" style={styles.container}>
      <div style={styles.header}>
        <h2 style={styles.title}>Soluções</h2>
      </div>

      <div
        style={styles.largeCardContainer}
        onMouseEnter={() => setIsHoveredLarge(true)}
        onMouseLeave={() => setIsHoveredLarge(false)}
      >
        <div style={styles.largeCardOuterBorder}></div>
        <div style={styles.largeCardWrapper}>
          <div style={styles.verticalBar}></div>
          <img src={gradientLargerCard} alt="Gradient Background" style={styles.cardImage} />
          <div style={{ ...styles.cardBlur, ...(isHoveredLarge ? styles.cardBlurHover : {}) }} />
          <div style={styles.largeCardContent}>
            <p style={styles.largeCardTitle}>
              Combinamos expertise em desenvolvimento de <strong>software</strong>, <strong>design</strong> e <strong>branding</strong> para transformar ideias em produtos de alto impacto.
            </p>
            <p style={styles.largeCardText}>
              Criamos plataformas web e aplicativos nativos em diversas linguagens, sempre considerando as melhores práticas de usabilidade e escalabilidade do seu produto. Nosso compromisso é ajudar marcas a crescer, unindo estética, inovação e resultados mensuráveis.
            </p>
          </div>
        </div>
      </div>

      <div style={styles.cardsWrapper}>
        {cards.map((card, i) => (
          <div
            key={i}
            style={styles.cardOuterBorder}
            onMouseEnter={() => card.setHover(true)}
            onMouseLeave={() => card.setHover(false)}
          >
            <div style={styles.card}>
              <img src={card.gradient} alt="Gradient Background" style={styles.cardImage} />
              <div style={{ ...styles.cardBlur, ...(card.isHovered ? styles.cardBlurHover : {}) }} />
              <div style={styles.cardContent}>
                <img src={card.icon} alt={`${card.title} Icon`} style={styles.cardIcon} />
                <h3 style={styles.cardTitle}>{card.title}</h3>
                <p style={styles.cardText}>{card.text}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default SolutionsMobile;
